function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLoanRequest1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5571"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17.75h7.5v-1.5h-7.5zm0-4h7.5v-1.5h-7.5zM6.3 21.5a1.793 1.793 0 0 1-1.8-1.8V4.3a1.793 1.793 0 0 1 1.8-1.8h7.95l5.25 5.25V19.7a1.793 1.793 0 0 1-1.8 1.8zm7.2-13V4H6.3a.354.354 0 0 0-.3.3v15.4a.354.354 0 0 0 .3.3h11.4a.354.354 0 0 0 .3-.3V8.5zM6 4z",
    transform: "translate(-.5 -.5)",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2533",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLoanRequest1);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGRhdGEtbmFtZT0iR3JvdXAgNTU3MSI+CiAgICAgICAgPHBhdGggZD0iTTguMjUgMTcuNzVoNy41di0xLjVoLTcuNXptMC00aDcuNXYtMS41aC03LjV6TTYuMyAyMS41YTEuNzkzIDEuNzkzIDAgMCAxLTEuOC0xLjhWNC4zYTEuNzkzIDEuNzkzIDAgMCAxIDEuOC0xLjhoNy45NWw1LjI1IDUuMjVWMTkuN2ExLjc5MyAxLjc5MyAwIDAgMS0xLjggMS44em03LjItMTNWNEg2LjNhLjM1NC4zNTQgMCAwIDAtLjMuM3YxNS40YS4zNTQuMzU0IDAgMCAwIC4zLjNoMTEuNGEuMzU0LjM1NCAwIDAgMCAuMy0uM1Y4LjV6TTYgNHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0uNSAtLjUpIiBzdHlsZT0iZmlsbDojNjY2Ii8+CiAgICAgICAgPHBhdGggZGF0YS1uYW1lPSJSZWN0YW5nbGUgMjUzMyIgc3R5bGU9ImZpbGw6bm9uZSIgZD0iTTAgMGgyNHYyNEgweiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };